module.exports = __webpack_public_path__ + "img/ICSMGE.75bfce99.svg";